import axios from "axios";
import buildUrl from 'build-url-ts';
import { CapabilitiesActionNeeded, IntegrationCapabilityList } from "src/types/settings/dashboard";

const BASE_URL = process.env.REACT_APP_API_URL;
const dashboardApiUrl = `${BASE_URL}/api/2.0/capability-mappings`;
const contentModeratorsApiUrl = `${BASE_URL}/api/2.0/accounts/content_moderators`;
const eventsApiUrl = `${BASE_URL}/api/2.0/capability-events`;
const activationApiUrl = `${BASE_URL}/api/2.0/capability-activation`;

export const dashboardApi = {

  fetchCapabilities: async (): Promise<IntegrationCapabilityList> => {
    const url = buildUrl(dashboardApiUrl, {
      queryParams: {
        withCount: 'true'
      }
    });

    const response = await axios.get(url);
    return response.data;
  },

  fetchContentModerators: async (): Promise<String[]> => {
    const url = buildUrl(contentModeratorsApiUrl);
    const response = await axios.get(url);
    return response.data;
  },

  updateContentModerators: async (data): Promise<{ userId: string }[]> => {
    const response = await axios.post(
      `${contentModeratorsApiUrl}`,
      data,
    );
    return response.data;
  },

  fetchCapabilitiesActionNeeded : async (): Promise<CapabilitiesActionNeeded[]> => {
    const url = buildUrl(`${dashboardApiUrl}/account/action`);
    const response = await axios.get(url);
    return response.data;
  },

  updateCapabilities: async (data): Promise<IntegrationCapabilityList> => {
    const response = await axios.post(
      `${dashboardApiUrl}`,
      data,
    );
    return response.data;
  },

  fetchEvents: async (page: number): Promise<any> => {
    const url = buildUrl(`${eventsApiUrl}`, {
      queryParams: {
        page
      }
    });
    const response = await axios.get(url);
    return response.data;
  },

  recordCapabilityActivation: async (key): Promise<any> => {
    const response = await axios.post(
      `${activationApiUrl}/${key}`,
    );
    return response.data;
  }

};
